function ordinal_suffix_of(i) {
  const j = i % 10;
  const k = i % 100;
  if (j == 1 && k != 11) {
    return i + 'st';
  }
  if (j == 2 && k != 12) {
    return i + 'nd';
  }
  if (j == 3 && k != 13) {
    return i + 'rd';
  }
  return i + 'th';
}

function determineDeliveryDate(days, isBusinessDays = true) {
  if (!days) return '';

  const deliveryDate = new Date();

  if (isBusinessDays) {
    // Add only Monday–Friday
    let remainingDays = days;

    while (remainingDays > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      const dayOfWeek = deliveryDate.getDay();

      // if it's not Saturday (6) or Sunday (0), it counts as a business day
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        remainingDays--;
      }
    }
  } else {
    deliveryDate.setDate(deliveryDate.getDate() + days);
  }

  // Now format
  const day = ordinal_suffix_of(deliveryDate.getDate());
  const month = deliveryDate.toLocaleString('default', { month: 'long' });

  return `${day} of ${month}`;
}

export default determineDeliveryDate;
